import { LOGOUT_USER } from './store';
export function rootReducer(reducer) {
    return function (state, action) {
        switch (action.type) {
            case LOGOUT_USER:
                state = undefined;
        }
        return reducer(state, action);
    };
}
export var metaReducers = [rootReducer];
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export function tokenGetter() {
    return localStorage.getItem('token');
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/app.module.ts.pre-build-optimizer.js